import { Outlet, Link, useNavigate } from 'react-router-dom'
import { ChevronLeft, KeyRound } from 'lucide-react'
import { useFamily } from '@/context/FamilyContext'

const avatarEmojis: Record<string, string> = {
  dragon: '🐉',
  unicorn: '🦄',
  robot: '🤖',
  astronaut: '👨‍🚀',
  wizard: '🧙',
  superhero: '🦸',
  cat: '🐱',
  dog: '🐕',
}

export function StorytellingLayout() {
  const navigate = useNavigate()
  const { activeWriter } = useFamily()
  const avatarEmoji = avatarEmojis[activeWriter?.avatar_id || 'dragon'] || '👤'

  return (
    <div
      className="min-h-screen"
      style={{
        background: 'linear-gradient(180deg, var(--color-story-bg) 0%, var(--color-story-bg-light) 40%, #ffffff 100%)',
      }}
    >
      {/* Header */}
      <header className="sticky top-0 z-40" style={{ background: 'linear-gradient(135deg, var(--color-story-primary), var(--color-story-primary-light))' }}>
        <div className="max-w-3xl mx-auto px-4 py-3">
          <div className="flex justify-between items-center">
            <button
              onClick={() => navigate('/dashboard')}
              className="flex items-center gap-1 text-white/80 hover:text-white transition-colors text-sm"
            >
              <ChevronLeft className="w-4 h-4" />
              Back to Hub
            </button>

            <div className="flex items-center gap-3">
              <Link
                to="/storytelling/secrets"
                className="flex items-center gap-1.5 text-white/80 hover:text-white transition-colors text-sm"
              >
                <KeyRound className="w-4 h-4" />
                <span className="hidden sm:inline">My Secrets</span>
              </Link>

              <span className="text-xl">{avatarEmoji}</span>
              <span className="text-white/90 text-sm font-medium hidden sm:inline">
                {activeWriter?.display_name}
              </span>
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main>
        <Outlet />
      </main>
    </div>
  )
}
